<script>
import { mapGetters } from 'vuex';
import { totalSeconds } from '../variables'
import '../filters';

export default {
  name: 'InfoLabels',
  data: () => {
    return {
    }
  },
  mounted() {
  },
  computed: {
    ...mapGetters({
      currentPlayerTrack: 'getCurrentPlayerTrack',
      currentPlayerTime: 'getCurrentPlayerTime'
    }),
    activeHotspots() {
      return this.currentPlayerTrack.hotspots.filter(spot => {
        const minDuration = 21 / window.outerWidth * totalSeconds;
        const duration = parseInt(spot.duration) < minDuration ? minDuration : spot.duration;
        return this.currentPlayerTime >= parseInt(spot.position) && this.currentPlayerTime < (parseInt(spot.position) + parseInt(duration));
      });
    },
  },
  methods: {
    onClick(pos) {
      this.$emit('timeUpdated', pos);
    }
  }
};
</script>

<template>
  <ul class="info-labels">
    <transition-group name="fade">
      <li class="info-label" v-for="spot in activeHotspots" v-bind:class="{'info-label--has-duration': spot.duration > 0}" v-bind:key="spot.label" v-on:click="onClick(spot.position)">
        <span class="info-label__icon"></span>
        <span class="info-label__time">
          {{ spot.position * 1000 | formatTime }}
        </span>
        <span v-if="spot.duration > 0" class="info-label__time-end">
          {{ (parseInt(spot.position) + parseInt(spot.duration)) * 1000 | formatTime }}
        </span>
        {{ spot.label }}
        <button class="info-label__button" v-on:click="onClick(spot.position)"></button>
      </li>
    </transition-group>
  </ul>
</template>

<style scoped lang="scss">
@import '../assets/styles/variables';

.info-labels {
  list-style-type: none;
  margin: 0; padding: 0;
  width: 100%;
}

.info-label {
  position: relative;
  font-family: var(--font-family-secondary);
  font-size: 1.25rem;
  line-height: 1.2;
  background-color: var(--light);
  color: var(--dark);
  box-sizing: border-box;
  padding: .5rem .5rem .5rem 6rem;
  margin: 0 auto .25rem;
  width: 37.5rem;
}
.info-label__time,
.info-label__time-end {
  position: absolute;
  display: block;
  left: 2.1rem;
  top: 0.7rem;
  font-size: 1rem;
  color: var(--dark);
  opacity: .75;
}
.info-label__time-end {
  top: 2rem;
}
.info-label__icon {
  position: absolute;
  display: block;
  left: .5rem;
  top: 0.75rem;
  width: 1rem;
  min-height: 1rem;
  background: #F48107;
  border-radius: .5rem;
  opacity: .72;
}
.info-label--has-duration .info-label__icon {
  height: 2.3125rem;
}
.info-label--has-duration {
  min-height: 3.7rem;
}
.info-label__button {
  position: absolute;
  right: .5rem;
  top: 50%;
  height: 2rem;
  width: 2rem;
  margin-top: -1rem;
  border: none;
  background: transparent url('~@/assets/images/ico-play.svg');
  background-size: 100%;
  opacity: .75;

  &:active,
  &:focus {
    outline: none;
  }
}

.fade-enter-active {
  transition: opacity 300ms linear, transform 200ms cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.fade-enter {
  opacity: 0;
  transform: translateY(4rem);
}
.fade-leave-active {
  transition: opacity 300ms linear;
}
.fade-leave-to {
  opacity: 0;
}
</style>
